import React from 'react';
import {GamesFilterStrategyBase} from "../games-filter-strategy-base";
import {AdvancedGamesFilterDrawerRenderer} from "./advanced-games-filter-drawer-renderer";
import {AdvancedStrategyFiltersEditor} from "./advanced-strategy-filters-editor";
import {IArenaGameFiltersCategory} from "../../arena-filters/categories/arena-game-filters-category.interface";
import {IGameFilterEvaluator} from "../../evaluators/game-filter-evaluator.interface";
import {AND} from "../../evaluators/and-game-filters-evaluator";
import {
    FiltersMobileButtonComponent
} from "../../../../components/header/top-header-left/filters/filters-mobile-button.component";
import {Nullable} from "../../../../../common/types/nullable-types";
import {
    IPcFilterIndicatorRenderingOptions,
    PcFilterIndicatorRenderingLocation
} from "../../games-filter.service.interface";
import {
    AppliedFiltersPcIndicatorForAdvancedFilteringComponent
} from "../../../../components/filters/advanced-filtering/indicators/pc-indicator/applied-filters-pc-indicator-for-advanced-filtering.component";
import {DynamicArenaGameFiltersCategory} from "../../arena-filters/categories/dynamic-arena-game-filters-category";
import {Check} from '@sparkware/app-utils';
import {FilterCategoryDefinitionFactory} from '../../filters-categories-definitions/filter-category-definition-factory';
import {IFilterCategoryDefinition} from '../../filters-categories-definitions/filter-category-definition.interface';

export class AdvancedGamesFilterStrategy extends GamesFilterStrategyBase {

    private _factory = new FilterCategoryDefinitionFactory(this.services);

    protected _createFiltersCategories(): IArenaGameFiltersCategory[] {
        const arenaName = this.services.routing.currentRoute.data?.arenaType;
        if (!arenaName) {
            return [];
        }

        const categories = this.services.configuration.data.arenas[arenaName]?.advancedFilters?.categories;
        if (!Check.isArray(categories)) {
            return [];
        }
        
        const filters: IArenaGameFiltersCategory[] = [];
        categories.forEach(category => {
            if (category?.id) {
                const filterCategoryDef = this._factory.createCategoryDefinition(category.id);
                if(filterCategoryDef) {
                    filters.push(this._createArenaGameFiltersCategory(filterCategoryDef));
                } else {
                    this.services.logger.error(`There is no filter category definition for id ${category.id}`);
                }
            }
        });

        return filters;
    }

    protected _createArenaGameFiltersCategory(filterCategoryDef: IFilterCategoryDefinition): IArenaGameFiltersCategory {
        return new DynamicArenaGameFiltersCategory(filterCategoryDef, this.services);
    }

    protected _createEvaluator(): IGameFilterEvaluator | null {
        return AND(...this.filtersCategories);
    }

    private _createFiltersEditor() {
        return new AdvancedStrategyFiltersEditor(this.filtersCategories, this.services);
    }


    renderMobileFiltersIndicator(): React.ReactElement {
        if(this.services.mediaQuery.lAndBelow) {
            return (<FiltersMobileButtonComponent/>);
        } else {
            return null;
        }
    }

    renderPCFiltersIndicator(): Nullable<IPcFilterIndicatorRenderingOptions> {
        if(this.services.mediaQuery.lAndBelow) {
            return null;
        } else {
            return {
                location: PcFilterIndicatorRenderingLocation.NextToArenaTitle,
                reactElement: (<AppliedFiltersPcIndicatorForAdvancedFilteringComponent filtersEditor={this._createFiltersEditor()}/>)
            };
        }
    }

    showFiltersEditor(): void {
        this.services.drawer.right.push(new AdvancedGamesFilterDrawerRenderer(this.services, this._createFiltersEditor()));
    }

}